// Microsoft Clarity no cardápio do cliente: gravação de sessão e mapa de calor
// numa conta do Núcleo (projeto "Núcleo - Cardápios"), um projeto só para todas
// as lojas, filtrado pela tag "loja". A loja não configura nada.
//
// Dado do cliente: o modo "Equilibrado" do projeto já esconde o que é digitado
// e palavras com número ou e-mail; nome e endereço exibidos em texto são
// escondidos com data-clarity-mask nas áreas do cardápio que mostram isso.
import { trackFunnel as trackFunnelBase } from "../../utils/trackFunnel";
import { getTenantSlug } from "../../utils/tenantScope";

const PROJETO = "ylwz5gtdzi";

// O painel também monta o cardápio (/admin/cardapio-admin): a visita do
// lojista não entra, senão contamina o funil e grava dado de dentro da loja.
const dentroDoPainel = () => /^\/admin(\/|$)/.test(window.location.pathname);

function chamar(...args) {
  try {
    if (typeof window.clarity === "function") window.clarity(...args);
  } catch { /* medição nunca quebra o cardápio */ }
}

export function iniciarClarityCardapio(modo) {
  if (typeof window === "undefined" || dentroDoPainel()) return;
  if (!window.__nucleoClarity) {
    window.__nucleoClarity = PROJETO;
    /* eslint-disable */
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", PROJETO);
    /* eslint-enable */
    chamar("set", "loja", getTenantSlug() || "desconhecida");
  }
  chamar("set", "modo", modo);
}

export function clarityEvento(nome) {
  if (typeof window === "undefined" || !window.__nucleoClarity) return;
  chamar("event", nome);
}

// Mesmo trackFunnel de utils/, espelhando cada degrau do funil no Clarity
// (cardapio_visit, cardapio_view, cardapio_cart, cardapio_revision).
export function trackFunnel(eventType, extra) {
  clarityEvento(`cardapio_${eventType}`);
  return trackFunnelBase(eventType, extra);
}
